module.exports = __webpack_public_path__ + "static/img/Band_nato_blackred.4362526.jpg";